import React from "react";
import styles from "./Btn.module.scss";
const Btn = (props) => {
  const { color, text, arrow, size, disabled, flash = false, delay, isActive } = props;
  let wrapClass = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_color_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_color_${color}`]}`;
  }
  if (size !== undefined && styles[`wrap_size_${size}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_size_${size}`]}`;
  }
  if (arrow !== undefined && arrow) {
    wrapClass += ` ${styles[`wrap_arrow`]}`;
  }
  if (disabled !== undefined && disabled) {
    wrapClass += ` ${styles[`wrap_disabled`]}`;
  }
  if (isActive !== undefined && isActive) {
    wrapClass += ` ${styles.active}`;
  }
  return (
    <>
      <div className={wrapClass}>
        <div className={styles.inner}>
          {text}
          {arrow !== undefined || size === "final" ?
            <svg className={styles.arrow__icon_1} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47708 15.5229 0 10 0C4.47708 0 0 4.47708 0 10C0 15.5229 4.47708 20 10 20Z" fill="#D6001C" />
              <path d="M5.68687 5.4873V8.88897C6.20479 8.27147 6.82563 7.96064 7.54563 7.96064C7.91646 7.96064 8.24854 8.03147 8.54646 8.17189C8.84521 8.31147 9.06854 8.49064 9.21938 8.70814C9.37104 8.92772 9.47354 9.16814 9.52896 9.43314C9.58396 9.69689 9.61146 10.1073 9.61146 10.664V14.3011H8.00229V11.0252C8.00229 10.3752 7.97312 9.96356 7.91187 9.78856C7.85449 9.61713 7.74065 9.47023 7.58896 9.37189C7.43396 9.26731 7.24104 9.21564 7.00812 9.21564C6.74146 9.21564 6.50229 9.2823 6.29437 9.4148C6.08188 9.54814 5.92938 9.74731 5.83271 10.0136C5.73438 10.2802 5.68521 10.674 5.68687 11.1952L5.68521 14.3011H4.07812V5.4873H5.68687ZM12.0231 5.4873V8.88897C12.5415 8.27147 13.1619 7.96064 13.8815 7.96064C14.251 7.96064 14.5856 8.03147 14.884 8.17189C15.1815 8.31147 15.4048 8.49064 15.5548 8.70814C15.7062 8.92626 15.8115 9.17295 15.8644 9.43314C15.9198 9.69689 15.9473 10.1073 15.9473 10.664V14.3011H14.3398V11.0252C14.3398 10.3752 14.3094 9.96356 14.2481 9.78856C14.1907 9.61689 14.0765 9.46992 13.9244 9.37189C13.771 9.26731 13.5765 9.21564 13.3435 9.21564C13.0773 9.21564 12.8381 9.2823 12.6298 9.4148C12.4202 9.54814 12.2669 9.74731 12.169 10.0136C12.0723 10.2802 12.0231 10.674 12.0231 11.1952V14.3011H10.416V5.4873H12.0231Z" fill="#FEFEFE" />
            </svg>

            : null
          }
          {arrow !== undefined ?
            size === 'final' ?
              <svg className={styles.arrow__icon_2} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.922 8.70711C23.3125 8.31658 23.3125 7.68342 22.922 7.29289L16.558 0.928932C16.1675 0.538408 15.5343 0.538408 15.1438 0.928932C14.7533 1.31946 14.7533 1.95262 15.1438 2.34315L20.8006 8L15.1438 13.6569C14.7533 14.0474 14.7533 14.6805 15.1438 15.0711C15.5343 15.4616 16.1675 15.4616 16.558 15.0711L22.922 8.70711ZM0.214844 9H22.2148V7H0.214844V9Z" fill="white" />
              </svg>

              :
              <svg className={styles.arrow__icon_2} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464466C8.97631 0.269204 8.65973 0.269204 8.46447 0.464466C8.2692 0.659728 8.2692 0.976311 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM0 4.5H12V3.5H0V4.5Z" fill="white" />
              </svg>
            : null
          }
        </div>
        {flash ?
          <div className={styles.flash}>
            <div className={styles.flash__light} style={delay !== undefined ? { animationDelay: `${delay}ms` } : null}></div>
          </div>
          : null}
        <div className={`${styles.bg} ${styles.bg_hover}`}></div>
        <div className={styles.bg}></div>
        <div className={`${styles.border} ${styles.border_hover}`}></div>
        <div className={styles.border}></div>
      </div>
    </>
  );

}

export default Btn;
